import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import AppCollapse from "components/ui/AppCollapse";
import AppButton from "components/ui/AppButton";
import AppIcon from "components/ui/AppIcon";
import { UTILS } from "utils";
import ModifierGroupDragger from "./ModiferGroupRowDraggable";
import AttachGroupModifierModal from "./AttachGroupModifier";
import useGroupModifierApi from "features/Modifier/useGroupModifierApi";
import UpdateModifierModal from "features/Modifier/UpdateModiferGroup";



const AttachItemToModifier = ({
  toBeAttachedCustomizations = [],
  setToBeAttachedCustomizations = () => {},
  toBeUnLinkCustomizations = [],
  setToBeUnLinkCustomizations = () => {},
  itemId = "",
  itemDetail = {},
  getItemDetail = () => {},
  mode = "edit",
  title = "Attach Customization",
  subtitle = "Attach Customization to the item",
  modalTitle = "Attach Customization",
  modalSubtitle = "Attach Customization to the item",
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [openModal, setOpenModal] = React.useState(false);
  const [customizations, setCustomizations] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [checkedRows, setCheckedRows] = React.useState([]);
  const [updateModal, setUpdateModal] = React.useState(false);
  const [customization, setCustomization] = React.useState(null);

  const {getAllModiferGroups, data, sortModiferGroupWithItem} = useGroupModifierApi();

  const removeDuplicateCustomizations = (customizations) => {
    return customizations.filter(
      (customization, index, self) =>
        index === self.findIndex((t) => t._id === customization._id)
    );
  };

  const actionRow = (record) => {
    return (
      <div className="flex gap-2 justify-end px-0 md:ps-3 whitespace-nowrap text-center flex-none ">
        <button
          onClick={() => {
            setUpdateModal(true);
            setCustomization(record);
          }}
        >
          <AppIcon name="edit" />
        </button>
        <button
          onClick={() => {
            setToBeAttachedCustomizations((prevState) => {
              const newCustomizations = prevState.filter(
                (customization) => customization._id !== record._id
              );
              return removeDuplicateCustomizations(newCustomizations);
            });
            setToBeUnLinkCustomizations((prevState) => {
              const newCustomizations = [...prevState, record];
              return removeDuplicateCustomizations(newCustomizations);
            });
          }}
        >
          <AppIcon name="trash" />
        </button>
      </div>
    );
  };
  console.log(toBeAttachedCustomizations, "toBeAttachedCustomizations");
  console.log(itemDetail, "itemDetail");

  const setItemCustomizations = (itemDetail) => {
    const normalizedCustomizations = itemDetail?.modifierGroups?.map(group => ({
      ...group?.modifierGroupId,
    }));
    setToBeAttachedCustomizations(normalizedCustomizations);
    setToBeUnLinkCustomizations([]);
  };

  React.useEffect(() => {
    if (itemDetail && Object.keys(itemDetail).length > 0) {
      setItemCustomizations(itemDetail);
    }
  }, [itemDetail]);

  React.useEffect(() => {
      getAllModiferGroups().then((data) => {
        setCustomizations(data.data);
      });
  }, []);

  return (
    <>
      <AppCollapse
        defaultOpen={toBeAttachedCustomizations?.length > 0}
        title={
          <div className="flex items-center justify-between">
            <span>{t(title)} ({toBeAttachedCustomizations?.length})</span>
            <AppButton
              variant="primaryOutline"
              size="md"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpenModal(true);
              }}
              // style={{ padding: "0px 20px" }}
            >
              {t("Attach Customization")}
            </AppButton>
          </div>
        }
        // subtitle={t(subtitle)}
      >
        <ModifierGroupDragger
          customizations={toBeAttachedCustomizations}
          actionButtons={actionRow}
          reOrderCategory={(order) => {
            sortModiferGroupWithItem({
              group: order,
              selected: toBeAttachedCustomizations?.[order.oldIndex],
              itemId: itemId,
              OnSuccess: () => {
                getItemDetail(itemId);
              },
            });
          }}
        />
      </AppCollapse>
      <AttachGroupModifierModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title={modalTitle}
        subtitle={modalSubtitle}
        customizations={customizations}  
        checkedRows={toBeAttachedCustomizations}
        toBeUnLinkCustomizations={toBeUnLinkCustomizations}
        setToBeUnLinkCustomizations={setToBeUnLinkCustomizations}
        toBeAttachedCustomizations={toBeAttachedCustomizations}
        setToBeAttachedCustomizations={setToBeAttachedCustomizations}
        setModal={setOpenModal}
        onAddNewCustomizationSuccess={() => {
          // The list is refreshed from the server below, so no optimistic
          // append is needed here (see UpdateModifierModal's onSuccess for
          // why an optimistic append is unsafe: callers disagree on shape).
          getAllModiferGroups().then((data) => {
            setCustomizations(data.data);
          });
        }}
      />
      <UpdateModifierModal
        as="modal"
        open={updateModal}
        onClose={() => {
          setUpdateModal(false);
          setCustomization(null);
        }}
        selectedCustomization={customization}
        onSuccess={() => {
          // Skip the optimistic append: the create and update mutations
          // hand their onSuccess callback different shapes (response body
          // vs. raw RTK Query result), so pulling "the customization" back
          // out here was fragile and could append a row with no `_id` --
          // exactly the payload that crashes the add-modifier-groups
          // validator on save. The refetch below always follows and
          // replaces the list with the real server state, so it is
          // sufficient on its own.
          getAllModiferGroups().then((data) => {
            setCustomizations(data.data);
          });
          setUpdateModal(false);
          setCustomization(null);
        }}
      />
    </>
  );
};

export default AttachItemToModifier;
